<template>
  <component
    v-if="template"
    :is="loadComponent()"
    :template="template"
    :theme="theme"
  ></component>
</template>

  <script>
import { mapState } from "vuex";
import { defineAsyncComponent } from "vue";
export default {
  watch: {
    template: function (val, old) {
      this.theme = val.nombre.toLowerCase();
    },
  },
  data: function () {
    return {
      theme: null,
    };
  },
  methods: {
    loadComponent() {
      if (this.template) {
        return defineAsyncComponent(() =>
          import(`@/${this.theme}/components/page.vue`)
        );
      }
    },
  },
  computed: {
    ...mapState("theme", ["template"]),
  },
};
</script>
